@if (showreport) {
  <ion-item [routerLink]="embedded ? null : ['/', 'showreports', showreport.id]"
    (click)="onItemClick($event)"
    [detail]="!embedded"
    [class.selected]="isSelected"
    class="showreport-item"
    [style.--accent-color]="accentColor">

    <div class="avatar-wrapper" slot="start">
      <app-show-avatar
        [imageUrl]="showreport?.performance?.show?.imageUrl"
        [showName]="showreport?.performance?.show?.name || 'Show'"
        size="medium">
      </app-show-avatar>
    </div>

    <ion-label class="item-content">
      <!-- Status badge -->
      @if (showreport.status === 'CONCEPT') {
        <ion-badge color="medium" class="status-badge">
          Concept
        </ion-badge>
      }

      <!-- Show name -->
      <h2 class="show-name">{{ showreport.performance?.show?.name }}</h2>

      <!-- Performance date and time -->
      <p class="performance-date">
        {{ showreport?.performance?.datetime | date:'EEEE d MMMM y':'CEST':'nl-NL' | titlecase }}
        <span class="performance-time">{{ showreport?.performance?.datetime | date:'HH:mm':'CEST':'nl-NL' }}</span>
      </p>

      <!-- Stagemanager / submitter name -->
      @if (submittedByName) {
        <p class="submitted-by">
          <ion-icon name="person-outline"></ion-icon>
          {{ submittedByName }}
        </p>
      }

      <!-- Technical checks -->
      @if (hasTechnicalChecks) {
        <div class="technical-checks">
          <app-showreport-technical-items-preview-list
            [showreport]="showreport"
            [show]="showreport.performance?.show"
            displayMode="icons-only"
            [clickable]="false">
          </app-showreport-technical-items-preview-list>
        </div>
      }
    </ion-label>
  </ion-item>
}
